import React from "react";
import Card from "react-bootstrap/Card";
import { GiSevenPointedStar } from "react-icons/gi";

function AboutCard() {
  return (
    // <Card className="quote-card-view">
    //   <Card.Body>
    //     <blockquote className="blockquote mb-0">
    //       <p style={{ textAlign: "justify" }}>
    //         Hi Everyone, I am <span className="purple">Cosmin Pascariu </span>
    //         from <span className="purple"> Romania.</span>
    //         <br />
    //         I am currently employed as a Mid React Native developer at <i>Assist Software</i>.
    //         <br />
    //         <br />
    //         Apart from coding, some other activities that I love to do!
    //       </p>
    //       <ul>
    //         <li className="about-activity">
    //           <GiSevenPointedStar /> Hitting the Gym
    //         </li>
    //         <li className="about-activity">
    //           <GiSevenPointedStar /> Sing
    //         </li>
    //         <li className="about-activity">
    //           <GiSevenPointedStar /> Travelling
    //         </li>
    //       </ul>

    //       <p style={{ color: "rgb(155 126 172)" }}>
    //         "Strive to build things that make a difference!"{" "}
    //       </p>
    //       <footer className="blockquote-footer">Soumyajit</footer>
    //     </blockquote>
    //   </Card.Body>
    // </Card>
    <Card className="quote-card-view">
  <Card.Body>
    <blockquote className="blockquote mb-0">
      <p style={{ textAlign: "justify" }}>
        Hi, I’m <span className="purple">Cosmin Pascariu</span>, a Front-end & Mobile
        Developer based in <span className="purple">Romania</span>. I build production-ready
        apps with <strong>React Native</strong> (iOS & Android) and modern web interfaces with
        <strong> React</strong> and <strong>TypeScript</strong>.
        <br />
        <br />
        I’m currently a <strong>Mid React Native Developer</strong> at <i>ASSIST Software</i>,
        focusing on state management, API integration, performance and smooth UX.
        {/* Optional: add 1–2 concrete wins */}
        {/* Recent highlights: cut app startup by ~20%, reduced bundle size, set up CI with GitHub Actions & Fastlane. */}
      </p>

      <ul>
        <li className="about-activity">
          <GiSevenPointedStar /> React Native, Expo • iOS/Android releases
        </li>
        <li className="about-activity">
          <GiSevenPointedStar /> React, Next.js • TypeScript, modern tooling
        </li>
        <li className="about-activity">
          <GiSevenPointedStar /> State & data: Redux Toolkit, Zustand, React Query
        </li>
        <li className="about-activity">
          <GiSevenPointedStar /> Performance & a11y • animations, code-splitting
        </li>
        <li className="about-activity">
          <GiSevenPointedStar /> CI/CD & tooling: GitHub Actions, Fastlane, Firebase
        </li>
      </ul>

      <p style={{ color: "rgb(155 126 172)" }}>
        I strive to build products that make a difference.
      </p>
    </blockquote>
  </Card.Body>
</Card>
  );
}

export default AboutCard;
